import { RestfulClient } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { Session } from '@benzinga/session';
import { SymbolsResult } from '../entities';
import { AutoCompleteEnvironment } from '../environment';

export class AutocompleteSymbolRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(AutoCompleteEnvironment).symbolsUrl, session);
  }

  /**
   * Takes input query makes restful request and returns list of symbols containing that term
   *
   * @param query - input query
   * @returns - list of symbols
   */
  public getAutoCompleteSymbols = async (query: string): SafePromise<SymbolsResult> => {
    const url = this.URL(`v2/autocomplete`, {
      apikey: this.session.getEnvironment(AutoCompleteEnvironment).symbolsKey,
      query,
    });
    return this.get<SymbolsResult>(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
